import { useState, useCallback } from 'react';



export function formatNumber(n) {
    let parts = n.toString().split(".");

    // Apply comma as thousands separator
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    // Ensure three decimal places
    if (parts[1]) {
        if (parts[1].length === 1) {
            parts[1] += "0"; // Add two zeros if there's only one digit
        } else if (parts[1].length === 2) {
            parts[1] += ""; // Add one zero if there are two digits
        } else if (parts[1].length > 3) {
            parts[1] = parts[1].substr(0, 3); // Truncate to three digits if longer
        }
        // No else needed for exactly three digits
    } else {
        parts[1] = "00"; // Add ".000" if there's no decimal part
    }

    return parts.join(".");
}
export function readableFormatDate(dateStr){
    const dateObj = new Date(dateStr);

    const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    const month = months[dateObj.getMonth()];
    const day = dateObj.getDate();
    const year = dateObj.getFullYear();
    const hours = dateObj.getHours() > 12 ? dateObj.getHours() - 12 : dateObj.getHours();
    const minutes = String(dateObj.getMinutes()).padStart(2, '0');
    const seconds = String(dateObj.getSeconds()).padStart(2, '0');
    const period = dateObj.getHours() >= 12 ? 'PM' : 'AM';

    const formattedDate = `${month} ${day}, ${year}, ${hours}:${minutes}:${seconds} ${period}`;
    return formattedDate;
}
export function maskSensitiveInfo(message) {
    // Remove HTML tags
    message = message.replace(/<[^>]*>?/gm, '');

    // Mask OTP
    message = message.replace(/\b(OTP\s*for\s*forgot\s*password\s*:\s*)\d+\b/gi, '$1****');

    // Mask Password
    message = message.replace(/\b(Password\s*:\s*)\S+\b/gi, '$1******');

    // Mask PIN
    message = message.replace(/(Pin\s*:\s*)\S+/gi, '$1******');

    return message;
}
export function formatDate(inputDate) {
    // Parse the input date
    const dateObject = new Date(inputDate);

    // Check if the date is valid
    if (isNaN(dateObject.getTime())) {
        return "Invalid Date";
    }

    // Format the date part (YYYY-MM-DD)
    const formattedDate = dateObject.toISOString().split('T')[0];

    // Check if the input date includes time
    if (inputDate.includes(':')) {
        // Format the date with time part (YYYY-MM-DD HH:MM:SS)
        const formattedDateTime = dateObject.toISOString().replace('T', ' ').split('.')[0];
        return formattedDateTime;
    }

    return formattedDate;
}

export function throttle(func, limit) {
  let inThrottle;
  return function(...args) {
    if (!inThrottle) {
      func.apply(this, args);
      inThrottle = true;
      setTimeout(() => inThrottle = false, limit);
    }
  };
}

export function useThrottle(callback, limit) {
  const [inThrottle, setInThrottle] = useState(false);

  const throttledCallback = useCallback((...args) => {
    if (!inThrottle) {
      callback(...args);
      setInThrottle(true);
      setTimeout(() => setInThrottle(false), limit);
    }
  }, [callback, limit, inThrottle]);

  return throttledCallback;
}
